<!-- <img src="../../../../assets/icon/user-sm.svg"> -->
<div *ngIf="isAuthenticated; else loggedOut" class="col-lg-12 col-sm-12 div-center" > 
    <div class="fb-box-user"> 
        <div class="left-image">
            <div class="img-avartar">
                <img [src]="urlAvartar" 
                    alt="User Image" 
                    [width]="userProfile?.picture?.data?.width"
                    [height]="userProfile?.picture?.data?.height"
                    loading="lazy"
                    (error)="avartarLoadError($event)"> 
            </div>
            
            <div class="img-fb-logo">
                <svg width="22px" height="22px" viewBox="0 0 24.00 24.00" fill="none" xmlns="http://www.w3.org/2000/svg"
                    stroke="#000000" stroke-width="0.00024000000000000003"> 
                    <g id="SVGRepo_bgCarrier" stroke-width="0"> 
                        <rect x="0" y="0" width="24.00" height="24.00" rx="12" fill="#fafafa" strokewidth="0" />
                    </g> 
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />  
                    <g id="SVGRepo_iconCarrier">
                        <path
                            d="M20 12.05C19.9813 10.5255 19.5273 9.03809 18.6915 7.76295C17.8557 6.48781 16.673 5.47804 15.2826 4.85257C13.8921 4.2271 12.3519 4.01198 10.8433 4.23253C9.33473 4.45309 7.92057 5.10013 6.7674 6.09748C5.61422 7.09482 4.77005 8.40092 4.3343 9.86195C3.89856 11.323 3.88938 12.8781 4.30786 14.3442C4.72634 15.8103 5.55504 17.1262 6.69637 18.1371C7.83769 19.148 9.24412 19.8117 10.75 20.05V14.38H8.75001V12.05H10.75V10.28C10.7037 9.86846 10.7483 9.45175 10.8807 9.05931C11.0131 8.66687 11.23 8.30827 11.5161 8.00882C11.8022 7.70936 12.1505 7.47635 12.5365 7.32624C12.9225 7.17612 13.3368 7.11255 13.75 7.14003C14.3498 7.14824 14.9482 7.20173 15.54 7.30003V9.30003H14.54C14.3676 9.27828 14.1924 9.29556 14.0276 9.35059C13.8627 9.40562 13.7123 9.49699 13.5875 9.61795C13.4627 9.73891 13.3667 9.88637 13.3066 10.0494C13.2464 10.2125 13.2237 10.387 13.24 10.56V12.07H15.46L15.1 14.4H13.25V20C15.1399 19.7011 16.8601 18.7347 18.0985 17.2761C19.3369 15.8175 20.0115 13.9634 20 12.05Z"
                            fill="#4568f5" />
                    </g> 
                </svg> 
            </div>
        </div>
        <div class="right-info">
            <div class="welcome">
                <span class="lb-wel">Welcome </span> 
            </div>
            <div class="user-name"> 
                <span>{{ userProfile?.name }}</span>
                <span class="btn-logout" (click)="logout()">
                    <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
                </span> 
            </div> 
        </div>
    </div>
</div>
<ng-template #loggedOut> 
    <div class="text-left">
        <button type="button" class="btn btn-primary facebook" (click)="login()">
            Facebook <i class="fab fa-facebook" aria-hidden="true"></i>
        </button>
    </div>
</ng-template>